import { render, staticRenderFns } from "./feeRoyaltyInstallment.vue?vue&type=template&id=95cd0b74&scoped=true"
import script from "./feeRoyaltyInstallment.vue?vue&type=script&lang=js"
export * from "./feeRoyaltyInstallment.vue?vue&type=script&lang=js"
import style0 from "./feeRoyaltyInstallment.vue?vue&type=style&index=0&id=95cd0b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cd0b74",
  null
  
)

export default component.exports